import produce from 'immer';
import { OPEN_ALERT } from '../actions/alerts';


const initialState = {
  open: false,
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case OPEN_ALERT: {
      const {data} = action;

      state.open = data;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
